var animarTest = {};
var animarGallery = {};
Boss.ui = {
	simpleMenu: function(id, tg){

		if(Boss.getById(id) && Boss.getById(tg)){

			Boss.evts.add('fakeresize', window, function(evt){

				var m = Boss.getById(id);
				var t = Boss.getById(tg);
				var p = m.parentElement;
				var li = m.querySelectorAll('li');
				var lis = li.length;

				var size = 0;
				for(var x = 0; x < lis; x++){
					size = size + li[x].clientWidth;
				}

				if(size > p.clientWidth){
					if(m.classList.contains('ui-simple-menu-collapse') === false){
						m.classList.add('ui-simple-menu-collapse');
						t.classList.remove('hidden');
					}
				}else{
					if(m.classList.contains('ui-simple-menu-collapse') === true){
						m.classList.remove('ui-simple-menu-collapse');
						t.classList.add('hidden');
					}
				}
			});
		}
	},
	testimonial: {
		mem: {},
		before: function(id){
			if(typeof(this.mem[id]) !== 'undefined'){
				if((this.mem[id].ativo - 1) > 0){
					this.mem[id].ativo = this.mem[id].ativo - 1;
				}else{
					this.mem[id].ativo =  this.mem[id].total - 1;
				}
			}
			this.render(id);
		},
		next: function(id){
			if(typeof(this.mem[id]) !== 'undefined'){
				if((this.mem[id].ativo + 1) < this.mem[id].total){
					this.mem[id].ativo = this.mem[id].ativo + 1;
				}else{
					this.mem[id].ativo = 0;
				}
			}
			this.render(id);
		},
		render: function(id){

			if(Boss.getById(id)){

				var ol = Boss.getById(id);
				var li = ol.getElementsByTagName('li');
				var lli = li.length;

				for(var x = 0; x < lli; x++){
					if(x == this.mem[id].ativo){
						li[x].classList.remove('hidden');
						li[x].classList.add('ux-testimonial-animate');
					}else{
						li[x].classList.add('hidden');
						li[x].classList.remove('ux-testimonial-animate');
					}
				}

				if(this.mem[id].height < ol.clientHeight){
					this.mem[id].height = ol.clientHeight;
					ol.style.minHeight = this.mem[id].height+'px';
				}
			}
		},
		init: function(id, t){

			if(typeof(t) === 'undefined'){
				var t = 6000;
			}

			if(Boss.getById(id)){

				var ol = Boss.getById(id);
				var li = ol.getElementsByTagName('li');
				var lli = li.length;

				this.mem[id] = {
					total: lli,
					ativo: 0,
					tempo: t,
					height: 0
				};

				this.render(id);

				clearInterval(animarTest[id]);

				animarTest[id] = setInterval(function(){
					Boss.ui.testimonial.next(id);
				}, this.mem[id].tempo);

				Boss.evts.add(Boss.evtTouchUp(), ol, function(evt){

					var el = Boss.targt(evt);
					if(el.nodeName !== 'BUTTON' && el.parentElement.nodeName === 'BUTTON'){
						el = el.parentElement;
					}
					if(el.nodeName !== 'BUTTON' && el.parentElement.parentElement.nodeName === 'BUTTON'){
						el = el.parentElement.parentElement;
					}

					if(el.classList.contains('ux-testimonial-lf')){

						Boss.ui.testimonial.before(id);
						clearInterval(animarTest[id]);

					}

					if(el.classList.contains('ux-testimonial-rg')){

						Boss.ui.testimonial.next(id);
						clearInterval(animarTest[id]);
					}
				});
			}
		}
	},
	numberIncreasing: function(el, num, fn, ms, fps){

		var delay = Math.round(1000 / fps);

		var num = Number(num);
		fn = Number(fn);

		var inc = ms / delay;
		inc = fn / inc;

		if(num + inc <= fn){
			num = num + inc;

			if(num >= el.getAttribute('data-num')){
				el.setAttribute('data-num', num);
				el.textContent = Boss.numberFormat(Math.round(num));
			}

			Boss.delay(function (){
				Boss.ui.numberIncreasing(el, num, fn, ms, fps);
			}, delay);

		}else{
			el.setAttribute('data-num', fn);
			el.textContent = Boss.numberFormat(fn);
		}
	},
	countDown: function(el, time, href){

		if(el !== null){

			var diff = 0;
			var days = 0;
			var h = 0;
			var m = 0;
			var s = 0;
			var c = (Date.now() / 1000).toFixed(0);

			if(time >= c){

				diff = time - c;

				/* VERIFICA DIAS */
				if(diff > 86400){
					days = Math.floor(diff / 86400);
					/* DESCONTA DIAS INTEIROS */
					diff = diff - (days * 86400);
				}

				/* VERIFICA HORAS */
				if(diff > 3600){
					h = Math.floor(diff / 3600);
					/* DESCONTA DIAS INTEIROS */
					diff = diff - (h * 3600);
					if(h < 10){
						h = '0'+h;
					}
				}

				/* VERIFICA MINUTOS */
				if(diff > 60){
					m = Math.floor(diff / 60);
					/* DESCONTA DIAS INTEIROS */
					diff = diff - (m * 60);
					if(m < 10){
						m = '0'+m;
					}
				}

				s = diff;
				if(s < 10){
					s = '0'+s;
				}

				el.innerHTML = '<div class="ui-countdown"><span class="ui-countdown-d">'+days+'</span>dias <span class="ui-countdown-h">'+h+'</span>h <span class="ui-countdown-m">'+m+'</span>m <span class="ui-countdown-s">'+s+'</span>s</div>';

				Boss.delay(function(){
					Boss.ui.countDown(el, time, href);
				}, 200);

			}else{
				window.location.href = href;
			}
		}
	},
	gallery: {
		mem: {},
		openscreen: function(el){

			if(Boss.getById(el)){

				var gallery = Boss.getById(el);
				gallery.setAttribute('data-full-screen', 'true');
				gallery.classList.add('ui-gallery-full-screen');

				if(Boss.ui.gallery.mem[el].enterFullScreem){
					Boss.ui.gallery.mem[el].enterFullScreem();
				}

				document.body.classList.add('lock');

				if(document.documentElement.requestFullscreen){
					document.documentElement.requestFullscreen();
				}else if(document.documentElement.mozRequestFullScreen){
					document.documentElement.mozRequestFullScreen();
				}else if(document.documentElement.webkitRequestFullscreen){
					document.documentElement.webkitRequestFullscreen();
				}else if(document.documentElement.msRequestFullscreen){
					document.documentElement.msRequestFullscreen();
				}
			}
		},
		exitscreen: function(el){

			if(Boss.getById(el)){

				var gallery = Boss.getById(el);

				gallery.removeAttribute('data-full-screen');
				gallery.classList.remove('ui-gallery-full-screen');

				if(Boss.ui.gallery.mem[el].exitFullScreem){
					Boss.ui.gallery.mem[el].exitFullScreem();
				}

				document.body.classList.remove('lock');

				if(document.exitFullscreen){
					document.exitFullscreen();
				}else if(document.mozCancelFullScreen){
					document.mozCancelFullScreen();
				}else if(document.webkitExitFullscreen){
					document.webkitExitFullscreen();
				}else if(document.msExitFullscreen){
					document.msExitFullscreen();
				}

				window.requestAnimationFrame(function(){
					Boss.ui.gallery.resize(el);
				});
			}
		},
		togglefull: function(el){

			if(Boss.getById(el)){
				var gallery = Boss.getById(el);
				if(!gallery.getAttribute('data-full-screen')){
					this.openscreen(el);
				}else{
					this.exitscreen(el);
				}
			}
		},
		setPhoto: function(el){

			if(Boss.getById(el)){

				if(this.mem[el].canvas && Boss.getById(this.mem[el].canvas)){
					Boss.getById(this.mem[el].canvas).classList.remove('hidden');
				}

				if(this.mem[el].video && Boss.getById(this.mem[el].video)){
					Boss.getById(this.mem[el].video).classList.add('hidden');
				}

				if(this.mem[el].bleft && Boss.getById(this.mem[el].bleft) && this.mem[el].lengthslides > 1){
					Boss.getById(this.mem[el].bleft).classList.remove('hidden');
				}else{
					Boss.getById(this.mem[el].bleft).classList.add('hidden');
				}

				if(this.mem[el].bright && Boss.getById(this.mem[el].bright) && this.mem[el].lengthslides > 1){
					Boss.getById(this.mem[el].bright).classList.remove('hidden');
				}else{
					Boss.getById(this.mem[el].bright).classList.add('hidden');
				}

				if(this.mem[el].play && Boss.getById(this.mem[el].play)){
					Boss.getById(this.mem[el].play).classList.remove('ui-gallery-btn-active');
				}

				if(this.mem[el].photo && Boss.getById(this.mem[el].photo)){
					Boss.getById(this.mem[el].photo).classList.add('ui-gallery-btn-active');
				}

				if(typeof(this.mem[el].playerControl.pauseVideo) !== 'undefined'){
					Boss.ui.gallery.mem[el].playerControl.pauseVideo();
				}
				if(typeof(this.mem[el].playerControl.pause) !== 'undefined'){
					Boss.ui.gallery.mem[el].playerControl.pause();
				}

				if(Boss.getById(this.mem[el].subtitle)){

					var subtitle = Boss.getById(this.mem[el].subtitle);
					subtitle.classList.remove('hidden');

				}
				Boss.ui.gallery.playSlider(el);
			}
		},
		setVideo: function(el){


			if(Boss.getById(el)){

				if(this.mem[el].canvas && Boss.getById(this.mem[el].canvas)){
					Boss.getById(this.mem[el].canvas).classList.add('hidden');
				}
				if(this.mem[el].video && Boss.getById(this.mem[el].video)){
					Boss.getById(this.mem[el].video).classList.remove('hidden');
				}

				if(this.mem[el].bleft && Boss.getById(this.mem[el].bleft)){
					Boss.getById(this.mem[el].bleft).classList.add('hidden');
				}

				if(this.mem[el].bright && Boss.getById(this.mem[el].bright)){
					Boss.getById(this.mem[el].bright).classList.add('hidden');
				}

				if(this.mem[el].play && Boss.getById(this.mem[el].play)){
					Boss.getById(this.mem[el].play).classList.add('ui-gallery-btn-active');
				}

				if(this.mem[el].photo && Boss.getById(this.mem[el].photo)){
					Boss.getById(this.mem[el].photo).classList.remove('ui-gallery-btn-active');
				}

				if(typeof(this.mem[el].playerControl.playVideo) !== 'undefined'){
					Boss.ui.gallery.mem[el].playerControl.playVideo();
				}
				if(typeof(this.mem[el].playerControl.play) !== 'undefined'){
					Boss.ui.gallery.mem[el].playerControl.play();
				}

				if(Boss.getById(this.mem[el].subtitle)){

					var subtitle = Boss.getById(this.mem[el].subtitle);
					subtitle.classList.add('hidden');

				}
				Boss.ui.gallery.stopSlider(el);
			}
		},
		setBackground: function(el){

			if(this.mem[el].background && Boss.getById(this.mem[el].background) && this.mem[el].current > 0){

				var background = Boss.getById(this.mem[el].background);
				var subtitle = Boss.getById(this.mem[el].subtitle);

				for(var ls = 0; ls < this.mem[el].lengthslides; ls++){
					if(ls == (this.mem[el].current - 1)){
						var img = this.mem[el].slides[ls].querySelector('img');
						if(this.mem[el].setBackground === true && img !== null){
							background.style.backgroundImage = 'url('+img.src+')';
						}
						if(subtitle !== null && img !== null && img.getAttribute('alt') && img.getAttribute('alt') !== ''){
							subtitle.textContent = img.getAttribute('alt');
							subtitle.classList.remove('hidden');
						}else{
							subtitle.textContent = '';
							subtitle.classList.add('hidden');
						}
						this.mem[el].slides[ls].classList.remove('hidden');
					}else{
						this.mem[el].slides[ls].classList.add('hidden');
					}
				}

			}
		},
		createId: function(elem){

			var id;
			if(elem !== null){
				if(elem.getAttribute('id')){
					id = elem.getAttribute('id');
				}else{
					id = 'id-'+Math.random().toString(36).substring(2);
					elem.setAttribute('id', id);
				}
			}

			return id;
		},
		before: function(el){

			var current = this.mem[el].current;
			var lengthslides = this.mem[el].lengthslides;

			if((current - 1) < 1){
				current = lengthslides;
			}else{
				current = current - 1;
			}

			this.mem[el].current = current;
			this.setBackground(el);
		},
		after: function(el){

			var current = this.mem[el].current;
			var lengthslides = this.mem[el].lengthslides;

			if((current + 1) <= lengthslides){
				current = current + 1;
			}else{
				current = 1;
			}
			this.mem[el].current = current;
			this.setBackground(el);

		},
		playSlider: function(el){

			if(Boss.getById(el)){

				clearInterval(animarGallery[el]);
				animarGallery[el] = setInterval(function(){
					Boss.ui.gallery.after(el);
				}, Boss.ui.gallery.mem[el].setTime);

			}
		},
		stopSlider: function(el){

			if(Boss.getById(el) && animarGallery[el] !== false){

				clearInterval(animarGallery[el]);

			}
		},
		resize: function(el){

			if(Boss.getById(el)){

				var gallery = Boss.getById(el);
				var width = gallery.querySelector('.ui-gallery-width');
				var canvas = gallery.querySelector('.ui-gallery-canvas');
				var video = gallery.querySelector('.ui-gallery-video');
				var subtitle;

				if(Boss.getById(Boss.ui.gallery.mem[el].subtitle)){
					subtitle = Boss.getById(Boss.ui.gallery.mem[el].subtitle);
				}


				if(canvas !== null){
					width.style.width = '20px';
					width.style.maxWidth = '20px';
					canvas.style.height = '20px';
				}
				if(video !== null){
					video.style.width = '20px';
					video.style.height = '20px';
				}

				/* ALTURA OK */
				if(gallery.clientWidth > (Boss.ui.gallery.mem[el].maxHeight * 1.777777)){

					var h = Math.floor(Boss.ui.gallery.mem[el].maxHeight * 1.777777);
					gallery.classList.remove('ui-gallery-drop');

					if(canvas !== null){
						width.style.width = h+'px';
						width.style.maxWidth = h+'px';
						canvas.style.height = Boss.ui.gallery.mem[el].maxHeight+'px';
					}

					if(video !== null){
						video.style.width = h+'px';
						video.style.height = Boss.ui.gallery.mem[el].maxHeight+'px';
					}

					if(subtitle !== null){
						subtitle.style.top = (Boss.ui.gallery.mem[el].maxHeight - 30)+'px';
					}

				/* CALCULA PELA LARGURA*/
				}else{

					var h = Math.floor(gallery.clientWidth / 1.777777);
					gallery.classList.add('ui-gallery-drop');

					if(canvas !== null){
						width.style.width = gallery.clientWidth+'px';
						width.style.maxWidth = gallery.clientWidth+'px';
						canvas.style.height = h+'px';
					}

					if(video !== null){
						video.style.width = gallery.clientWidth+'px';
						video.style.height = h+'px';
					}

					if(subtitle !== null){
						subtitle.style.top = (h - 30)+'px';
					}
				}
			}
		},
		init: function(el, config){

			if(typeof(config) === 'undefined'){
				var config = {};
			}

			if(Boss.getById(el)){

				clearInterval(animarGallery[el]);

				var maxHeight = false;
				var setBackground = false;
				var setTime = 6000;
				var slides = [];

				if(config.maxHeight){
					maxHeight = config.maxHeight;
				}

				if(config.setBackground && config.setBackground === true){
					setBackground = config.setBackground;
				}

				if(config.setTime && config.setTime > 0){
					setTime = config.setTime * 1000;
				}

				var screensizes = Boss.screensizes();
				lastWidth = screensizes.viewWidth;

				var gallery = Boss.getById(el);

				var background = gallery.querySelector('.ui-gallery-background');

				var width = gallery.querySelector('.ui-gallery-width');
				var canvas = gallery.querySelector('.ui-gallery-canvas');
				var video = gallery.querySelector('.ui-gallery-video');

				var player = gallery.querySelector('.ui-gallery-player');
				var id_player = this.createId(player);

				var full = gallery.querySelector('.ui-gallery-full');

				var photo = gallery.querySelector('.ui-gallery-photo');
				var play = gallery.querySelector('.ui-gallery-play');

				var bleft = gallery.querySelector('.ui-gallery-left');
				var bright = gallery.querySelector('.ui-gallery-right');

				var subtitle = gallery.querySelector('.ui-gallery-subtitle');

				/* PREVENT DRAG */
				var start = false;
				var end = false;
				Boss.evts.add('dragstart', gallery, function(evts){
					if(evts.stopPropagation){
						evts.stopPropagation();
					}
					if(evts.preventDefault){
						evts.preventDefault();
					}
				});

				/* CREATE SUBTITLE */
				if(subtitle === null){

					subtitle = document.createElement('div');
					subtitle.classList.add('ui-gallery-subtitle');
					subtitle.classList.add('hidden');
					width.appendChild(subtitle);
				}

				/* FIND SLIDES */
				if(canvas !== null){

					slides = canvas.querySelectorAll('.ui-gallery-canvas-img');
					var lengthslides = 0;
					var current = 0;

					if(slides.length > 0){
						lengthslides = slides.length;
						current = 1;

						for(var ls = 0; ls < lengthslides; ls++){
							if(ls == 0){
								slides[ls].classList.remove('hidden');
							}else{
								slides[ls].classList.add('hidden');
							}
						}
					}

				}else{
					photo.classList.add('hidden');
				}

				var playerControl;

				this.mem[el] = {
					'background': this.createId(background),
					'slides': slides,
					'lengthslides': lengthslides, 
					'current': current, 
					'canvas': this.createId(canvas),
					'subtitle': this.createId(subtitle),
					'video': this.createId(video),
					'photo': this.createId(photo),
					'play': this.createId(play),
					'bleft': this.createId(bleft),
					'bright': this.createId(bright),
					'maxHeight': maxHeight,
					'playerControl': false,
					'interval': false,
					'setBackground': setBackground,
					'setTime': setTime
				};

				window.requestAnimationFrame(function(){
					Boss.ui.gallery.resize(el);
				});

				if(background !== null){
					Boss.ui.gallery.setBackground(el);
				}

				if(photo !== null){

					Boss.evts.add('click', photo, function(evts){
						Boss.ui.gallery.setPhoto(el);
					});
				}

				if(play !== null){

					Boss.evts.add('click', play, function(evts){
						Boss.ui.gallery.setVideo(el);
					});
				}

				if(full !== null){

					Boss.evts.add('click', full, function(evts){
						Boss.ui.gallery.togglefull(el);
					});
				}

				if(bleft !== null){

					Boss.evts.add('click', bleft, function(evts){
						Boss.ui.gallery.before(el);
						Boss.ui.gallery.stopSlider(el);
					});
				}

				if(bright !== null){

					Boss.evts.add('click', bright, function(evts){
						Boss.ui.gallery.after(el);
						Boss.ui.gallery.stopSlider(el);
					});
				}

				if(lengthslides > 1){
					Boss.evts.add('keydown', document, function(evts){

						if(evts.keyCode == 27){
							Boss.ui.gallery.exitscreen(el);
						}

						/* LEFT OR SPACE */
						if(evts.keyCode === 37 || evts.keyCode === 32){

							Boss.ui.gallery.before(el);
							Boss.ui.gallery.stopSlider(el);

						/* RIGHT */
						}else if(evts.keyCode === 39){

							Boss.ui.gallery.after(el);
							Boss.ui.gallery.stopSlider(el);
						}
					});

					Boss.evts.add('mousemove', canvas, function(evts){
						if(evts.buttons == 1 && start === false){
							start = evts.pageX;
						}
						if(start !== false){

							var current = Boss.ui.gallery.mem[el].current;
							var divs = Boss.ui.gallery.mem[el].slides;
							var drag = (start - evts.pageX) * -1;
							divs[(current - 1)].style.transform = 'translateX('+drag+'px)';
							divs[(current - 1)].style.opacity = Math.abs(Math.cos(Math.abs(drag) * 2 / Boss.getById(el).clientWidth)).toFixed(2);

						}
						end = evts.pageX;
					});
					Boss.evts.add('mouseup', canvas, function(evts){
						if(start !== false){
							var drag = start - end;
							if(Math.abs(drag) >= 20){
								if(drag > 0){

									clearInterval(animarGallery[el]);
									Boss.ui.gallery.before(el);

								}else{
									clearInterval(animarGallery[el]);
									Boss.ui.gallery.after(el);

								}

								Boss.ui.gallery.stopSlider(el);

							}
						}
						var divs = Boss.ui.gallery.mem[el].slides;
						var t = Boss.ui.gallery.mem[el].lengthslides;
						for(var x = 0; x < t; x++){
							divs[x].removeAttribute('style');
						}
						start = false;
						end = false;
					});
					Boss.evts.add('mouseout', canvas, function(evts){
						if(start !== false){
							var drag = start - end;

							if(Math.abs(drag) >= 20){
								if(drag > 0){

									clearInterval(animarGallery[el]);
									Boss.ui.gallery.before(el);

								}else{

									clearInterval(animarGallery[el]);
									Boss.ui.gallery.after(el);

								}
								Boss.ui.gallery.stopSlider(el);
							}
						}
						var divs = Boss.ui.gallery.mem[el].slides;
						var t = Boss.ui.gallery.mem[el].lengthslides;
						for(var x = 0; x < t; x++){
							divs[x].removeAttribute('style');
						}
						start = false;
						end = false;
					});

					Boss.evts.add('touchmove', canvas, function(evts){
						if(start === false){
							start = evts.targetTouches[0].pageX;
						}
						if(start !== false){

							window.requestAnimationFrame(function(){

								var at = Boss.ui.gallery.mem[el].current;
								var divs = Boss.ui.gallery.mem[el].slides;
								var drag = (start - evts.targetTouches[0].pageX) * -1;
								divs[at].style.transform = 'translateX('+drag+'px)';
								divs[at].style.opacity = Math.abs(Math.cos(Math.abs(drag) * 2 / Boss.getById(el).clientWidth)).toFixed(2);

							});

						}
						end = evts.targetTouches[0].pageX;
					});
					Boss.evts.add('touchend', canvas, function(evts){
						if(start !== false){
							var drag = start - end;

							if(Math.abs(drag) >= 20){
								if(drag > 0){

									clearInterval(animarGallery[el]);
									Boss.ui.gallery.before(el);

								}else{

									clearInterval(animarGallery[el]);
									Boss.ui.gallery.after(el);

								}
								Boss.ui.gallery.stopSlider(el);
							}
						}
						var divs = Boss.ui.gallery.mem[el].slides;
						var t = Boss.ui.gallery.mem[el].lengthslides;
						for(var x = 0; x < t; x++){
							divs[x].removeAttribute('style');
						}
						start = false;
						end = false;
					});
				}

				/* RESIZE */
				Boss.evts.add('fakeresize', window, function(evts){

					var screensizes = Boss.screensizes();
					if(lastWidth != screensizes.viewWidth){

						window.requestAnimationFrame(function(){
							Boss.ui.gallery.resize(el);
						});
					}
				});

				gallery.style.overflow = 'visible';


				/* FIND VIDEO */
				if(video === null){

					play.classList.add('hidden');

				}else{

					if(config.video && config.video.id && config.video.type){

						if(config.video.type == 'youtube'){

							var tag = document.createElement('script');
							tag.src = "https://www.youtube.com/player_api";
							var firstScriptTag = document.getElementsByTagName('script')[0];
							firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

							Boss.evts.add('load', tag, function(evts){
								window.onYouTubePlayerAPIReady = function(){
									playerControl = new YT.Player(id_player, {
										height: '360',
										width: '640',
										playerVars: {'autoplay': 0, 'controls': 2, 'rel': 0, 'showinfo': 0},
										videoId: config.video.id,
									});
									Boss.ui.gallery.mem[el].playerControl = playerControl;
								}
							});

							if(typeof(YT) !== 'undefined'){
								playerControl = new YT.Player(id_player, {
									height: '360',
									width: '640',
									playerVars: {'autoplay': 0, 'controls': 2, 'rel': 0, 'showinfo': 0},
									videoId: config.video.id,
								});
								Boss.ui.gallery.mem[el].playerControl = playerControl;
							}

							Boss.ui.gallery.setVideo(el);
						}

						if(config.video.type == 'facebook'){

							Boss.getById(id_player).setAttribute('data-href', config.video.id);
							Boss.getById(id_player).classList.add('fb-video');


							if(typeof(FB) !== 'undefined'){

								FB.XFBML.parse();

								FB.Event.subscribe('xfbml.ready', function(msg){
									if(msg.type === 'video' && msg.id === id_player){
										Boss.ui.gallery.mem[el].playerControl = msg.instance;
									}
								});
							}

							Boss.evts.add('load', Boss.getById('facebook-jssdk'), function(evts){
								FB.Event.subscribe('xfbml.ready', function(msg){
									if(msg.type === 'video' && msg.id === id_player){
										Boss.ui.gallery.mem[el].playerControl = msg.instance;
									}
								});
							});

							Boss.ui.gallery.setVideo(el);
						}
					}else{

						if(play !== null){

							play.classList.add('hidden');
						}

						if(photo !== null){
							photo.classList.add('hidden');
						}

						Boss.ui.gallery.setPhoto(el);
					}
				}
			}
		}
	},
	bigImage: {
		init: function(img, label){

			var mask = '<div id="boss-bigimage-close" class="boss-bigimage-close"><i class="fa fa-times" aria-hidden="true"></i></div><div class="boss-bigimage-label">'+label+'</div><img alt="imagem" src="'+img+'" />';

			if(Boss.getById('boss-bigimage')){
				var div = Boss.getById('boss-bigimage');
				div.innerHTML = mask;
			}else{
				var div = document.createElement('div');
				div.setAttribute('id', 'boss-bigimage');
				div.classList.add('boss-bigimage');
				div.innerHTML = mask;
				document.body.appendChild(div);
			}

			var screensizes = Boss.screensizes();
			var alt = screensizes.viewHeight;

			div.classList.remove('hidden');
			div.style.height = alt+'px';

			/*document.body.classList.add('lock');*/

			Boss.evts.add(Boss.evtTouchUp(), div, function(evt){
				var el = Boss.targt(evt);
				if(el.classList.contains('boss-bigimage')){
					el.classList.add('hidden');
				}
			});

			Boss.evts.add(Boss.evtTouchUp(), Boss.getById('boss-bigimage-close'), function(evt){
				var el = Boss.getById('boss-bigimage');
				el.classList.add('hidden');
				/*document.body.classList.remove('lock');*/
			});
		}
	}
};